import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import colorMapBotonBrillante from '../../../utils/colorMapBotonBrillante';
import styles from './BotonChico02.module.css';

const BotonChico02 = ({ texto, direccion, bgColor, current }) => {
  const navigate = useNavigate();

  const dirigirHacia = () => {
    navigate(direccion);
  };

  let colorElegido =
    colorMapBotonBrillante[bgColor] || colorMapBotonBrillante['blue'];

  if (current) {
    const currentColorKey = `${bgColor}_current`;
    colorElegido = colorMapBotonBrillante[currentColorKey];
  }

  return (
    <button
      className={clsx(
        current
          ? styles[`${bgColor}-current`]
          : styles[`${bgColor}-shine-background`],
        current
          ? 'text-yellow-50 text-xs md:text-sm'
          : 'text-gray-300 text-xs md:text-sm',
        'py-2 md:py-3 px-3 md:px-0 mx-0.5 md:mx-1 font-bold rounded-lg border-4 transition pixel-button w-full min-w-0 md:min-w-[165px] max-w-full md:max-w-[220px] hover:text-yellow-50',
        colorElegido.bg,
        colorElegido.border,
        colorElegido.hoverBg,
        colorElegido.hoverBorder,
        colorElegido.hoverShadow
      )}
      onClick={dirigirHacia}
    >
      <span>{texto}</span>
    </button>
  );
};

export default BotonChico02;
